export const FlashcardType = {
  cloze: 'Fill in the blank',
  question: 'Question and Answer',
  imageOcclusion: 'Image Occlusion'
};

export const PowerpointContentType = {
  slideAndNotes: 'Slide Content + Notes Section',
  slideOnly: 'Slide Content Only',
  notesOnly: 'Notes Section Only'
};
